/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_R_SecurityInputs */

const en_mk_nav_r_security = /** @type {(inputs: Mk_Nav_R_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Security & data`)
};

const id_mk_nav_r_security = /** @type {(inputs: Mk_Nav_R_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keamanan & data`)
};

/**
* | output |
* | --- |
* | "Security & data" |
*
* @param {Mk_Nav_R_SecurityInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_r_security = /** @type {((inputs?: Mk_Nav_R_SecurityInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_R_SecurityInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_r_security(inputs)
	return en_mk_nav_r_security(inputs)
});